import { useQuery } from '@tanstack/react-query'
import { MaterialService } from '../services/materialService'
import { startOfDay, subDays } from 'date-fns'

interface UseMaterialsQuery {
  search: string
  limit?: number
  skip?: number
  sort?: string
  startDate?: string
  endDate?: string
}

export const useMaterialsQuery = ({
  search,
  limit = 99,
  skip = 0,
  sort = 'dateLiberation',
  startDate = startOfDay(subDays(new Date(), 30)).toISOString(),
  endDate,
}: UseMaterialsQuery) => {
  return useQuery({
    queryKey: ['materials', search, limit, skip, sort, startDate, endDate],
    queryFn: () =>
      MaterialService.getMaterials({
        search,
        limit,
        skip,
        sort,
        startDate,
        endDate,
      }),
  })
}
